import { useEffect } from 'react';

export default function SEO({ title, description }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    let meta = document.querySelector('meta[name="description"]');
    const prevDescription = meta ? meta.getAttribute('content') : '';
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    if (description) meta.setAttribute('content', description);

    return () => {
      if (title) document.title = prevTitle;
      if (description && meta) meta.setAttribute('content', prevDescription || '');
    };
  }, [title, description]);

  return null;
}
